module.exports = __webpack_public_path__ + "90cebd0203923f50ad3649ec595f68ec.svg";